module.exports = __webpack_public_path__ + "img/mural.6c5dad85.jpg";